import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove platform-injected badge if it appears (mutation observer)
const killBadge = () => {
  document
    .querySelectorAll('#emergent-badge, a[href*="emergent.sh"]')
    .forEach((el) => el.remove());
};
killBadge();
if (typeof MutationObserver !== "undefined") {
  new MutationObserver(killBadge).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
